var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossCircle = function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "#A0FF7E",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5.5a7 7 0 1 0 .001 14.001A7 7 0 0 0 7.5.5m2.584 9.66-1.03-.005L7.5 8.303l-1.552 1.85-1.032.005a.124.124 0 0 1-.125-.125q0-.046.03-.081L6.852 7.53 4.82 5.11a.125.125 0 0 1 .095-.206l1.033.004L7.5 6.759l1.552-1.85 1.03-.004c.07 0 .126.054.126.125a.13.13 0 0 1-.03.08l-2.03 2.421 2.032 2.422a.125.125 0 0 1-.095.206"
  })));
};
export default SvgCrossCircle;